module.exports = __webpack_public_path__ + "img/mGT-notuse.98ddd45f.png";